import CompanyList from '@/pages/components/company-info/company/CompanyList';

export default {
  list: CompanyList,
  recordRepresentation: 'companyName',
};
